import { useLanguage, useNextTranslation } from "../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../product/ProductBookNowButton";
import type { ExternalWidgetVentrata as ExternalWidgetVentrataType } from "../../types/ExternalWidget";

export type ExternalWidgetVentrataProps = Omit<ExternalWidgetVentrataType, "__typename"> & {
    ButtonComponent?: (props: ProductBookNowButtonProps) => JSX.Element;
};

export function ExternalWidgetVentrata({ productId, apiKey, ButtonComponent }: ExternalWidgetVentrataProps) {
    const [t] = useNextTranslation("externalWidget");
    const lang = useLanguage();
    const Button = ButtonComponent ?? ProductBookNowButton;

    const referrer = window.location.host;
    const btnDataConfig = { productID: productId, lang: lang.codeShort, referrer };

    return (
        <Button
            type="button"
            data-button-text={t("ventrata.availabilityButton.dataText")}
            data-config={JSON.stringify(btnDataConfig)}
            disabled={!apiKey}
            ventrata-checkout="true"
        >
            {t("ventrata.availabilityButton.label")}
        </Button>
    );
}
